//show and hide the stack options


// $(document).ready(function() {
//   $('.stack-main-buider').hide();

//   function resetStackBuilder() {
//     $('.stack-main-buider')
//       .removeAttr('id')
//       .removeClass('maxxing_recommended community_picks build_own');

//     $('.selected_products_block')
//       .removeClass('maxxing_recommended community_picks build_own');
//   }

//   $('#maxxing_recommended').on('click', function() {
//     resetStackBuilder();
//     $('.stack-main-buider')
//       .show()
//       .addClass('maxxing_recommended')
//       .attr('id', 'maxxing_recommended_stack');

//     $('.selected_products_block')
//       .addClass('maxxing_recommended')
//       .removeClass('community_picks build_own');
//   });

//   $('#community_picks').on('click', function() {
//     resetStackBuilder();
//     $('.stack-main-buider')
//       .show()
//       .addClass('community_picks')
//       .attr('id', 'community_picks_stack');

//     $('.selected_products_block')
//       .addClass('community_picks')
//       .removeClass('maxxing_recommended build_own');
//   });

//   $('#build_your_own').on('click', function() {
//     resetStackBuilder();
//     $('.stack-main-buider')
//       .show()
//       .addClass('build_own')
//       .attr('id', 'build_own_stack');

//     $('.selected_products_block')
//       .addClass('build_own')
//       .removeClass('maxxing_recommended community_picks');
//   });
// });






// $(document).ready(function() {

//   // Hide the main builder initially
//   $('.stack-main-buider').hide();

//   // List of all stack classes
//   const stackClasses = [
//     'maxxing_recommended',
//     'community_picks',
//     'build_own',
//     'skin_maxxing',
//     'looks_maxxing',
//     'gym_maxxing'
//   ];

//   function resetStackBuilder() {
//     // Remove classes from main builder
//     $('.stack-main-buider')
//       .removeAttr('id')
//       .removeClass(stackClasses.join(' '));

//     // Hide all stack result blocks
//     $('.my_selections').hide();

//     // Remove classes from selected products area
//     $('.selected_products_block').removeClass(stackClasses.join(' '));
//   }

//   function handleStack(type) {
//     resetStackBuilder();

//     // Show builder
//     $('.stack-main-buider')
//       .show()
//       .addClass(type)
//       .attr('id', type + '_stack');

//     // Show correct stack output block
//     $('.' + type + '.my_selections').show();

//     // Add class to right column
//     $('.selected_products_block').addClass(type);
//   }


//   // BUTTONS — EXACT IDs FROM  HTML
//   $('#skin_maxxing').on('click', function() { handleStack('skin_maxxing'); });
//   $('#looks_maxxing').on('click', function() { handleStack('looks_maxxing'); });
//   $('#gym_maxxing').on('click', function() { handleStack('gym_maxxing'); });

//   $('#maxxing_recommended').on('click', function() { handleStack('maxxing_recommended'); });
//   $('#community_picks').on('click', function() { handleStack('community_picks'); });
//   $('#build_your_own').on('click', function() { handleStack('build_own'); });

// });





// $(document).ready(function() {

//   // Hide builder at start
//   $('.stack-main-buider').hide();

//   // Every stack type should match right-block class names
//   const stackClasses = [
//     'skin_maxxing',
//     'looks_maxxing',
//     'gym_maxxing',
//     'maxxing_recommended',
//     'community_picks',
//     'build_own'
//   ];

//   function resetStackBuilder() {
//     $('.stack-main-buider')
//       .removeAttr('id')
//       .removeClass(stackClasses.join(' '))
//       .hide();

//     $('.my_selections').hide();

//     $('.selected_products_block')
//       .removeClass(stackClasses.join(' '));
//   }

//   function handleStack(type) {
//     resetStackBuilder();

//     // Show builder + apply stack type class
//     $('.stack-main-buider')
//       .show()
//       .addClass(type)
//       .attr('id', type + '_stack');

//     // Show correct stack items block
//     $('.' + type + '.my_selections').show();

//     // Highlight correct right-side panel
//     $('.selected_products_block').addClass(type);
//   }

//   // Auto-bind for ALL dynamic block buttons
//   $(document).on('click', '.stack-btn', function (e) {
//     e.preventDefault();

//     let type = $(this).data('stack');  // pulled from dynamic slug
//     handleStack(type);
//   });

// });

$(document).ready(function() {

  // Hide builder at start
  $('.stack-main-buider').hide();

  // Detect all stack types from data-mode attributes
  const stackTypes = [...new Set($("[data-mode]").map(function() {
    return $(this).data("mode");
  }).get())];

  console.log("Detected stack types:", stackTypes);

  function resetStackBuilder() {
    $('.stack-main-buider').hide().removeAttr('id');
    $('.my_selections').hide();
    $('.selected_products_block').removeClass(stackTypes.join(' '));
  }

  function handleStack(type) {
    resetStackBuilder();

    // Show builder + apply stack type class
    $('.stack-main-buider')
      .show()
      .attr('id', type + '_stack');

    // Show correct stack items block
    $('.' + type + '.my_selections').show();

    // Highlight correct right-side panel
    $('.selected_products_block').addClass(type);
  }

  // Auto-bind for all dynamic block buttons
  $(document).on('click', '.stack-btn', function(e) {
    e.preventDefault();

    // Use data-mode because that's what your buttons output
    let type = $(this).data('mode');  
    if (!type) return;

    handleStack(type);
  });

});


$('.stack-btn').on('click', function () {
    const target = $('.stack-main-buider');
    target.show();  // or whatever reveals it

    setTimeout(() => {
        $('html, body').animate({
            scrollTop: target.offset().top
        }, 600);
    }, 50);  // small delay ensures correct height
});
